<template>
    <div class="Partners">
        <div class="PartnersWidth">
            <indexTitle :title="title" :more="false"></indexTitle>
            <div class="listBox">
                <div @click="itemClick(item, index)" :key="item.id" v-for="(item, index) in content" class="itemBox">
                    <div class="name">{{ item.title }}</div>
                    <img class="image" :src="item.cover" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import indexTitle from "@/components/c/indexTitle.vue"
export default {
    components: {
        indexTitle,
    },
    data() {
        return {

        }
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        content: {
            type: Array,
            default: (() => [])
        },
    },
    created() {

    },
    mounted() {

    },
    methods: {
        itemClick(data, index) {
            this.$emit('itemClick', { data, index })
        },
    }
}
</script>

<style scoped lang="scss">
.Partners {
    background: #ffffff;
    padding-top: 0px;
    padding-bottom: 150px;
    margin-top: 116px;

    .PartnersWidth {
        width: 1200px;
        margin: auto;

        .listBox {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 50px;
            gap: 30px;

            .itemBox {
                width: 380px;
                height: 380px;
                margin-bottom: 0px;
                background: #F8F7F7;
                position: relative;
                cursor: pointer;

                .name {
                    position: absolute;
                    left: 0;
                    top: 40px;
                    width: 100%;
                    text-align: center;
                    font-size: 24px;
                    color: #000000;
                    line-height: 32px;
                }

                .image {
                    width: 380px;
                    height: 380px;
                    display: block;
                    object-fit: cover;
                }
            }
        }
    }
}

@media screen and (max-width:1200px) {

    .Partners {
        background: #ffffff;
        padding-top: 0px;
        padding-bottom: 50px;
        margin-top: 50px;

        .PartnersWidth {
            width: 100%;
            margin: auto;

            .listBox {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin-top: 50px;
                gap: 30px;

                .itemBox {
                    width: calc((100% - 30px) / 2);
                    height: auto;
                    margin-bottom: 0px;
                    background: #F8F7F7;
                    position: relative;
                    cursor: pointer;

                    .name {
                        position: absolute;
                        left: 0;
                        top: 15px;
                        width: 100%;
                        text-align: center;
                        font-size: 18px;
                        color: #000000;
                        line-height: 32px;
                    }

                    .image {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 1/1;
                        display: block;
                        object-fit: cover;
                    }
                }
            }
        }
    }
}
</style>